/* Подпись-правило под рядом «Кто повторит» (§20.1 п. 5, §1.8: щит и «Только свои фото или с согласием человека на фото»).
   Сервер требует явного согласия (consent_accepted, policy.consent_required): правило стоит отметкой — права на материалы
   и согласие человека на фото даются одним касанием и в черновике не хранятся. */
import { uiText } from '../../i18n';
import type { CircleFormState } from '../studio/circle/CircleFieldInput';
import { ToolIcon } from '../studio/circle/ToolIcon';

export const MOTION_RULE = 'Только свои фото или с согласием человека на фото';
export function MotionConsent({ state }: { state: CircleFormState }) {
  const checked = state.rights && state.inputs.consent_accepted === 'true';
  return (
    <label className={`bc-cap motion-consent${checked ? ' on' : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        disabled={state.locked}
        onChange={e => {
          /* значение берётся сразу: управляемый флажок React вернёт до вызова отложенного обновления */
          const on = e.target.checked;
          state.setRights(on);
          state.setInputs(v => ({ ...v, consent_accepted: on ? 'true' : 'false' }));
        }}
      />
      <ToolIcon kind="shield" />
      <span>{uiText(MOTION_RULE)}</span>
    </label>
  );
}
